// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";
import TimelineItemStore from "app/stores/TimelineItemStore";
import VideoStore from "app/stores/VideoStore";
import VideoEditorStore from "app/stores/VideoEditorStore";
import VideoPlayerStore from "app/stores/VideoPlayerStore";

import TimelineWizard from "app/components/TimelineWizard/TimelineWizard";

type Props = {
    addSignFollowMouse?: boolean
};

@observer
export default class TimelineWizardContainer extends React.Component<Props> {
    handleWizard = () => {
        TimelineItemStore.requestCreate(VideoPlayerStore.progress);
    };

    getProgressAndHighlight = (): [number, boolean] => {
        if (this.props.addSignFollowMouse) {
            const progress = VideoEditorStore.hoverProgress;
            if (process) {
                // $FlowFixMe
                return [progress, false];
            }
        }

        const progress = VideoPlayerStore.progress;
        let highlight = false;

        if (!TimelineItemStore.items.length) {
            highlight = true;
        }

        return [progress, highlight];
    };

    render() {
        if (
            !VideoStore.isEditable ||
            TimelineItemStore.wizard ||
            AppearanceStore.scale === -1
        )
            return null;

        const [progress, highlight] = this.getProgressAndHighlight();

        const video = VideoStore.video;

        const style = {
            left: `${(progress * 100) / video.duration}%`
        };

        return (
            <div className="TimelineWizardContainer" style={style}>
                <TimelineWizard
                    video={video}
                    progress={progress}
                    onClick={this.handleWizard}
                    highlight={highlight}
                    disabled={!TimelineItemStore.canAddAt(progress)}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/TimelineWizardContainer.js